<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Access Notes'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <tidy-card-button (action)="goToUploadAccessNotes()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <!--TODO add a better icon-->
            <tidy-image [src]="'assets/img/integrate.svg'" style="width: 20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Upload Access Notes'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Upload a CSV file with access notes for your property.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-row class="extra-bottom-padding">
      <tidy-text [helper]="'or'" class="divider" />
    </tidy-row>

    @for (form of forms.controls; track form) {
      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="card-header">
            <tidy-text [header]="form.value.address_name" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding" [alignLastItemRight]="true">
            <tidy-image [src]="'assets/img/car.svg'" class="body-size" />
            <tidy-text [body]="'How to Park'" />
            <tidy-text [body]="'Add Photo'" (action)="getImg(form, 'parking')" class="link" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/car.svg'"
              [label]="'What kind of parking?'"
              [form]="form.controls.paid_parking"
              formControlName="paid_parking"
              [items]="parkingTypes"
              (optionChange)="clearFields(form)" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/location.svg'"
              [label]="'What kind of spot?'"
              [form]="form.controls.parking_spot"
              formControlName="parking_spot"
              [items]="form.controls.paid_parking.value ? paidParkingSpots : freeParkingSpots" />
          </tidy-row>
          @if (form.controls.paid_parking.value) {
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/card.svg'"
                [label]="'How will you pay?'"
                [form]="form.controls.parking_pay_with"
                formControlName="parking_pay_with"
                [items]="payOptions" />
            </tidy-row>
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/cash.svg'"
                [label]="'How much will you reimburse?'"
                [form]="form.controls.max_parking_cost"
                formControlName="max_parking_cost"
                [items]="maxCostOptions" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-input
              [icon]="'assets/svg/create.svg'"
              [label]="'Any notes to help park?'"
              formControlName="parking_notes"
              [form]="form.controls.parking_notes" />
          </tidy-row>
          <photo-caption
            [photoUrls]="form.value.parkingPhotoUrls"
            (deletePhoto)="confirmDelete($event, form)"
            [type]="'parking'" />
          <tidy-row class="extra-bottom-padding extra-top-padding" [alignLastItemRight]="true">
            <tidy-image [src]="'assets/img/unlock.svg'" class="body-size" />
            <tidy-text [body]="'How to Get In'" />
            <tidy-text [body]="'Add Photo'" (action)="getImg(form, 'access')" class="link" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [icon]="'assets/svg/key.svg'"
              [label]="'How do they access the property?'"
              formControlName="home_access"
              [form]="form.controls.home_access" />
          </tidy-row>
          <photo-caption
            [photoUrls]="form.value.accessPhotoUrls"
            (deletePhoto)="confirmDelete($event, form)"
            [type]="'access'" />
          <tidy-row class="extra-bottom-padding extra-top-padding" [alignLastItemRight]="true">
            <tidy-image [src]="'assets/img/lock.svg'" class="body-size" />
            <tidy-text [body]="'How to Close Up'" />
            <tidy-text class="link" [body]="'Add Photo'" (action)="getImg(form, 'closing')" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [icon]="'assets/svg/lock-closed.svg'"
              [label]="'What should they do as they leave?'"
              formControlName="home_close"
              [form]="form.controls.home_close" />
          </tidy-row>
          <photo-caption
            [photoUrls]="form.value.closingPhotoUrls"
            (deletePhoto)="confirmDelete($event, form)"
            [type]="'closing'" />
        </form>
      </tidy-card>
    }

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    <tidy-button [action]="boundSave" [text]="'Save'" class="primary" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
